import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";
import { BaseResponse } from "../_types";

interface MerchantBlackListCheckRequest {
    merchantName: string;
    taxNumber: string;
}

export function useMerchantBlackListCheck() {
    return useMutation<BaseResponse<any>, AxiosError, MerchantBlackListCheckRequest>(
        async (data) => {
            const response = await axiosInstance.post(
                "/Merchant/MerchantBlackListService",
                data
            );
            return response.data;
        }
    );
}